import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const isoToDate = (iso) => { const [y, m, d] = iso.split("-").map(Number); return new Date(y, m - 1, d); };
export const dateToIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const auLabel = (iso) => `${isoToDate(iso).toLocaleDateString("en-AU", { weekday: "short" })} ${iso.split("-").reverse().join("/")}`;

// Calendar popover picker; value/onChange use ISO (YYYY-MM-DD).
export const DatePickerButton = ({ value, onChange, testid, label, className = "", marked = [], footer }) => {
  const [open, setOpen] = useState(false);
  const days = marked.map(isoToDate);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testid} className={`inline-flex items-center gap-2 ${className}`}>
          <CalendarDays className="w-4 h-4" />{label ?? (value ? auLabel(value) : "Pick a date")}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-[#131C31] border-[#202E4C] text-slate-100" data-testid={`${testid}-calendar`}>
        <Calendar mode="single" weekStartsOn={1} selected={value ? isoToDate(value) : undefined}
          defaultMonth={value ? isoToDate(value) : days[days.length - 1]}
          onSelect={(d) => { if (d) { onChange(dateToIso(d)); setOpen(false); } }}
          modifiers={{ meeting: days }}
          modifiersClassNames={{ meeting: "font-bold text-blue-300 underline decoration-blue-500 decoration-2 underline-offset-4" }}
          classNames={{
            day_selected: "!bg-blue-600 !text-white hover:!bg-blue-600 no-underline",
            day_today: "ring-1 ring-slate-500",
            head_cell: "text-slate-500 rounded-md w-8 font-normal text-[0.8rem]",
            day_outside: "text-slate-600 opacity-50",
          }} />
        {footer && <p className="px-3 pb-3 text-[11px] text-slate-500">{footer}</p>}
      </PopoverContent>
    </Popover>
  );
};
